import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import { defineComponent as _defineComponent } from 'vue';
import { useRecipesWishlists } from '~/composables/useRecipesWishlists';
import AzInput from '~/components/_next/atoms/AzInput.vue';
import AzButton from '~/components/_next/atoms/AzButton.vue';
import AzSidebar from '~/components/_next/molecules/AzSidebar.vue';
import { RECIPE_WISHLIST_MAX_CHAR } from '~/constants/recipesConstants';
export default /*#__PURE__*/_defineComponent({
  __name: 'SidebarCreateRecipeWishlistOrganism',
  setup: function setup(__props) {
    var _useNuxt2App = useNuxt2App(),
      i18n = _useNuxt2App.i18n;
    var wishlistName = ref('');
    var createErrorText = ref('');
    var _useRecipesWishlists = useRecipesWishlists(),
      addRecipesWishlist = _useRecipesWishlists.addRecipesWishlist,
      canAddNewList = _useRecipesWishlists.canAddNewList,
      validateRecipeName = _useRecipesWishlists.validateRecipeName;
    var _useUiState = useUiState(),
      toggleCreateRecipeWishlistSidebar = _useUiState.toggleCreateRecipeWishlistSidebar;
    var hasValidated = ref(false);
    var hasName = computed(function () {
      return wishlistName.value.length !== 0;
    });
    watch(function () {
      return wishlistName.value;
    }, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (hasName.value && !hasValidated.value && wishlistName.value.length > RECIPE_WISHLIST_MAX_CHAR) {
              hasValidated.value = true;
              createErrorText.value = validateRecipeName(wishlistName.value);
            } else if (wishlistName.value.length < RECIPE_WISHLIST_MAX_CHAR) {
              hasValidated.value = false;
              createErrorText.value = '';
            }
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));

    /**
     * Creates a recipes wishlist.
     */
    function createRecipesWishlist() {
      return _createRecipesWishlist.apply(this, arguments);
    }
    /**
     * Closes the sidebar.
     */
    function _createRecipesWishlist() {
      _createRecipesWishlist = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return addRecipesWishlist(wishlistName.value);
            case 2:
              createErrorText.value = _context2.sent;
              if (!createErrorText.value && hasName.value) {
                closeSidebar();
              }
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _createRecipesWishlist.apply(this, arguments);
    }
    function closeSidebar() {
      wishlistName.value = '';
      createErrorText.value = '';
      toggleCreateRecipeWishlistSidebar();
    }
    return {
      __sfc: true,
      i18n: i18n,
      wishlistName: wishlistName,
      createErrorText: createErrorText,
      addRecipesWishlist: addRecipesWishlist,
      canAddNewList: canAddNewList,
      validateRecipeName: validateRecipeName,
      toggleCreateRecipeWishlistSidebar: toggleCreateRecipeWishlistSidebar,
      hasValidated: hasValidated,
      hasName: hasName,
      createRecipesWishlist: createRecipesWishlist,
      closeSidebar: closeSidebar,
      AzInput: AzInput,
      AzButton: AzButton,
      AzSidebar: AzSidebar
    };
  }
});